import React, { createContext, useContext, useState, useCallback } from 'react';
import RegistrationModal from '@/components/RegistrationModal';

const SignupContext = createContext(null);

/**
 * Global signup provider — renders the simplified public registration modal
 * so any "Register" CTA across the site opens the same popup.
 */
export function SignupProvider({ children }) {
  const [open, setOpen] = useState(false);

  const openSignup = useCallback(() => setOpen(true), []);
  const closeSignup = useCallback(() => setOpen(false), []);
  // Legacy alias kept so older callers keep working.
  const openLeadModal = openSignup;

  return (
    <SignupContext.Provider value={{ open, openSignup, closeSignup, openLeadModal }}>
      {children}
      <RegistrationModal open={open} onOpenChange={setOpen} />
    </SignupContext.Provider>
  );
}

export function useSignup() {
  const ctx = useContext(SignupContext);
  if (!ctx) throw new Error('useSignup must be used within SignupProvider');
  return ctx;
}
